import { Button, DatePicker } from "antd";
import React, { FC, useState } from "react";
import { formateTimeToAMPM, getWeekDay } from "../../../../utils/DateUtils";
import arLocale from "antd/es/date-picker/locale/ar_EG";
import enLocale from "antd/es/date-picker/locale/en_US";

import "dayjs/locale/ar";
import dayjs from "dayjs";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { location } from "../../../../types/calendar";

interface DatePickerProps {
  dateAndTime: {
    date: Date | null;
    startTime: string | null;
    finishTime: string | null;
  };
  setDateAndTime?: React.Dispatch<
    React.SetStateAction<{
      date: Date | null;
      startTime: string | null;
      finishTime: string | null;
    }>
  >;
  step: number;
}

const DateAndTimePicker: FC<DatePickerProps> = ({
  dateAndTime,
  setDateAndTime,
  step,
}) => {
  const intl = useIntl();
  const { currentLang, activeLocation } = useSelector(
    (state: {
      user: { currentLang: "en" | "ar" };
      calendar: { activeLocation: location | null };
    }) => {
      return {
        currentLang: state?.user?.currentLang,
        activeLocation: state.calendar.activeLocation,
      };
    }
  );
  const weekDays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const workingDays: string[] =
    activeLocation?.opening_hours?.map((day) => day?.day) || [];
  const [showDatePicker, setShowDatePicker] = React.useState(
    (dateAndTime?.date && dateAndTime?.startTime === null) || false
  );
  const pickedHour = Number(dateAndTime.startTime?.split(":")[0] || 9);

  const pickedMinutes = Number(dateAndTime.startTime?.split(":")[1] || 0);
  const [minutes, setMinutes] = useState(pickedMinutes);
  const [hours, setHours] = useState(
    pickedHour > 12 ? pickedHour - 12 : pickedHour
  );
  const [AMPM, setAMPM] = useState(pickedHour > 12 ? "PM" : "AM");
  const handleChangeMinutes = (type: "inc" | "dec") => {
    if (type === "inc") {
      if (minutes === 59) {
        setMinutes((pre) => 0);
      } else {
        setMinutes((pre) => pre + 1);
      }
    } else {
      if (minutes === 0) {
        setMinutes((pre) => 59);
      } else {
        setMinutes((pre) => pre - 1);
      }
    }
  };
  const handleChangeHours = (type: "inc" | "dec") => {
    if (type === "inc") {
      if (hours === 12) {
        setHours((pre) => 1);
      } else {
        setHours((pre) => pre + 1);
      }
    } else {
      if (hours === 0) {
        setHours((pre) => 12);
      } else {
        setHours((pre) => pre - 1);
      }
    }
  };
  const handleChangeAMPM = () => {
    setAMPM((pre) => (pre === "AM" ? "PM" : "AM"));
  };
  const handleSetDateAndTime = () => {
    const formatedHour =
      AMPM === "PM"
        ? hours > 11
          ? hours
          : hours + 12
        : hours === 12
        ? 0
        : hours;
    if (!setDateAndTime) return;
    setDateAndTime({
      ...dateAndTime,
      startTime: `${formatedHour < 10 ? `0${formatedHour}` : formatedHour}:${
        minutes < 10 ? `0${minutes}` : minutes
      }`,
    });
    setShowDatePicker(!showDatePicker);
  };
  return (
    <div className="w-full">
      <div className="w-full">
        <Button
          disabled={step > 3}
          type="default"
          htmlType="submit"
          className="w-full p-2 my-2 border-color-primary"
          onClick={() => {
            setShowDatePicker(!showDatePicker);
          }}
        >
          <div className="flex justify-center gap-4 ">
            {dateAndTime?.date ? (
              <div className=" ">
                <span className="text-color-gray">
                  {" "}
                  {intl.formatMessage({
                    id: "day",
                    defaultMessage: "يوم",
                  })}{" "}
                </span>
                <span>
                  {getWeekDay(dateAndTime?.date, currentLang)}{" "}
                  {new Date(dateAndTime?.date).getDate()}{" "}
                  {new Date(dateAndTime?.date).toLocaleString(
                    currentLang === "ar" ? "ar" : "en",
                    {
                      month: "long",
                    }
                  )}
                </span>
              </div>
            ) : (
              <div className=" text-color-primary">
                {" "}
                {intl.formatMessage({
                  id: "day",
                  defaultMessage: "يوم",
                })}{" "}
              </div>
            )}

            <div className=" text-color-secondary"> | </div>
            <div className=" text-color-primary">
              {dateAndTime?.startTime ? (
                <span>
                  <span className="text-color-gray">
                    {" "}
                    {intl.formatMessage({
                      id: "hour",
                      defaultMessage: "الساعة",
                    })}{" "}
                  </span>
                  {formateTimeToAMPM(dateAndTime?.startTime, currentLang)}
                </span>
              ) : (
                <span>
                  {" "}
                  {intl.formatMessage({
                    id: "hour",
                    defaultMessage: "الساعة",
                  })}{" "}
                </span>
              )}
            </div>
          </div>
        </Button>
      </div>
      {showDatePicker ? (
        <div>
          <DatePicker
            placeholder={intl.formatMessage({
              id: "pickDate",
              defaultMessage: "اختر التاريخ",
            })}
            value={dateAndTime?.date ? dayjs(dateAndTime?.date) : null}
            disabledDate={(date: any) => {
              if (!date) return false;
              const currenDate = dayjs(date);

              const day = weekDays[currenDate.day()];

              const d = new Date();
              d.setDate(d.getDate() - 1);
              return date.isBefore(d) || workingDays.indexOf(day) === -1;
            }}
            locale={currentLang === "ar" ? arLocale : enLocale}
            className="w-full p-2 my-2 border-color-primary"
            size="small"
            format={"YYYY-MM-DD"}
            disabled={!setDateAndTime}
            onChange={(value) => {
              if (!setDateAndTime) return;
              setDateAndTime({
                ...dateAndTime,
                date: new Date((value?.toDate() as Date) || null),
              });
            }}
          />
          <div
            dir="rtl"
            className="my-2 text-color-primary flex justify-center gap-3 items-center bg-white w-fit mx-auto px-3 shadow-lg rounded text-[#454545] "
          >
            <div className="flex flex-col gap-1">
              <Button
                type="link"
                htmlType="button"
                onClick={() => handleChangeMinutes("inc")}
              >
                <IoIosArrowUp size={20} />
              </Button>

              <input
                type="number"
                className="remove-arrow  text-center text-color-primary text-xl w-[30px] m-auto border-none outline-none
                [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none
                "
                max={59}
                min={0}
                maxLength={2}
                value={minutes < 10 ? `0${minutes}` : minutes}
                // value={minutes}
                onChange={(e) => {
                  if (e.target.value.includes(".")) {
                    return;
                  }
                  if (Number(e.target.value) > 59) {
                    setMinutes(59);
                  } else if (Number(e.target.value) < 0) {
                    setMinutes(0);
                  } else {
                    setMinutes(Number(e.target.value));
                  }
                }}
              />
              <Button
                type="link"
                htmlType="button"
                onClick={() => handleChangeMinutes("dec")}
              >
                <IoIosArrowDown size={20} />
              </Button>
            </div>
            <div className="flex flex-col gap-2">:</div>
            <div className="flex flex-col gap-1">
              <Button
                type="link"
                htmlType="button"
                onClick={() => handleChangeHours("inc")}
              >
                <IoIosArrowUp size={20} />
              </Button>

              <input
                type="number"
                className="remove-arrow  text-color-primary text-center text-xl w-[30px] m-auto border-none outline-none
                [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none
                "
                maxLength={2}
                max={12}
                min={1}
                value={hours > 9 ? hours : `0${hours}`}
                // value={hours}
                onChange={(e) => {
                  if (e.target.value.includes(".")) {
                    return;
                  }
                  if (Number(e.target.value) > 12) {
                    setHours(12);
                  } else {
                    setHours(Number(e.target.value));
                  }
                }}
              />
              <Button
                type="link"
                htmlType="button"
                onClick={() => handleChangeHours("dec")}
              >
                <IoIosArrowDown size={20} />
              </Button>
            </div>

            <div className="flex flex-col gap-1">
              <Button type="link" htmlType="button" onClick={handleChangeAMPM}>
                <IoIosArrowUp size={20} />
              </Button>
              <span className="text-xl text-center">
                {AMPM === "AM"
                  ? currentLang === "ar"
                    ? "ص "
                    : "AM"
                  : currentLang === "ar"
                  ? "م "
                  : "PM"}
              </span>
              <Button type="link" htmlType="button" onClick={handleChangeAMPM}>
                <IoIosArrowDown size={20} />
              </Button>
            </div>
          </div>
          <div className="my-2 text-center">
            <Button
              type="primary"
              htmlType="button"
              onClick={handleSetDateAndTime}
            >
              تم
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DateAndTimePicker;
